import { IBuilding } from '../building';
import { ISuite } from './suite';
import { IUser } from './user';

export enum ResidentRole {
    tenant = 'rent',
    owner_off_site = 'owner_off',
    owner_on_site = 'owner_on',
    resident = 'resident',
    resident_owner = 'resident_owner',
    resident_only_not_on_deed = 'resident_only_not_on_deed',
    owner_family = 'owner_family',
    guest = 'guest',
    offsite_resident = 'offsite_resident',
    occupant = 'occupant',
    staff = 'staff',
    not_set = 'unknown'
}

export interface ISuiteUser {
    id?: number;
    building: IBuilding|number;
    role: ResidentRole;
    importedAt: Date;
    moveOutDate: Date;
    occupancyDate: Date;
    suite: ISuite|number;
    user: IUser;
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/building/suite-user.ts